<template>
  <div class="container-fluid">
    <div class="left-page">
      <div class="left-item">
        <div class="left-search">
          <input class="form-control" type="text" placeholder="搜尋問卷標題" />
        </div>
        <div class="left-group">
          <span class="left-group-title">問卷群組</span>
        </div>
        <div class="left-group-item">
          <div class="left-group-title">
            <div class="left-group-text">我的問卷</div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-page">
      <div class="right-header">
        <div class="right-header-text">
          <h4>我的問卷</h4>
        </div>
      </div>
      <div class="grid-wrap">
        <div class="grid">
          <div class="button-group">
            <div class="add-button" @click="createNewForm">
              <span>新增問卷</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    createNewForm() {
      this.$router.push({ path: "/manager/survey/create" });
    },
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  padding: 0;
  flex: 1 1 0%;
  display: flex;
  .left-page {
    width: 256px;
    height: 100%;
    border-right: 1px solid rgb(238, 238, 238);
    background-color: rgb(250, 250, 250);
    display: flex;
    flex-direction: column;
    .left-item {
      flex: 1 1 0%;
      padding: 8px;
      display: flex;
      flex-direction: column;
      -webkit-box-pack: start;
      justify-content: start;
      -webkit-box-align: center;
      align-items: center;
      height: calc(100% - 48px);
    }
    .left-search {
      width: 213px;
      height: 32px;
      margin: 16px 0px;
      position: relative;
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;
    }
    .left-group {
      margin-bottom: 4px;
      width: 100%;
      height: 32px;
      padding: 15px;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
      .left-group-title {
        color: rgb(69, 69, 69);
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        margin: 0px;
        overflow: hidden;
        white-space: nowrap;
      }
      .left-group-icon {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 15px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
      }
    }
    .left-group-item {
      flex-shrink: 0;
      margin-bottom: 4px;
      width: 100%;
      height: 32px;
      font-size: 14px;
      border: none;
      border-radius: 4px;
      padding: 5px 14px;
      display: flex;
      -webkit-box-pack: center;
      justify-content: center;
      align-items: center;
      background-color: rgb(209, 240, 229);
      color: rgb(61, 186, 144);
      .left-group-title {
        width: 100%;
        display: flex;
        align-items: center;
        -webkit-box-pack: justify;
        justify-content: space-between;
        position: relative;
        .left-group-text {
          color: inherit;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
          padding-right: 30px;
        }
      }
    }
  }
  .right-page {
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
    height: 100%;
    padding: 24px 24px 0px;
    background-color: #fff;
    overflow: hidden;
    .right-header {
      max-height: 100px;
      margin-bottom: 13px;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      .right-header-text {
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        min-width: 0px;
        h4 {
          color: inherit;
          font-weight: 500;
          font-size: 24px;
          line-height: 32px;
          margin: 0px;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
        }
      }
    }
    .grid-wrap {
      display: flex;
      flex-direction: column;
      flex: 1 1 0%;
      margin-right: -15px;
      .grid {
        box-sizing: border-box;
        direction: ltr;
        position: relative;
        width: 1185px;
        will-change: transform;
        overflow: hidden;
        height: 722px;
        margin-top: 0px;
        padding-top: 1px;
        .button-group {
          width: 976px;
          height: 160px;
          max-width: 976px;
          max-height: 160px;
          overflow: visible;
          position: relative;
          margin: 0px 0px 0px 2px;
          .add-button {
            cursor: pointer;
            height: 60px;
            left: 0px;
            position: absolute;
            top: 0px;
            width: 120px;
            border-radius: 4px;
            border: 1px solid rgb(61, 186, 144);
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              font-size: 14px;
              color: rgb(61, 186, 144);
              font-weight: 500;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
}
</style>
